import { FC, useEffect, useState } from 'react';

import { BaseCustomComponentVideo } from '../add-element';

import * as Styled from './subtitles.styles';

export type Subtitle = {
  id: any;
  label: any;
  sources?: {
    type: string;
    source: string;
  }[];
};
type SubtitleState = Subtitle & {
  selected: boolean;
};

type Props = BaseCustomComponentVideo & {
  xingPlayer: XingPlayer;
  subtitles: Subtitle[];
  shouldDisplaySubtitle?: boolean;
};
export const Subtitles: FC<Props> = ({
  xingPlayer,
  player,
  shouldDisplaySubtitle,
  ...props
}) => {
  const [subtitles, setSubtitles] = useState<SubtitleState[]>([]);

  useEffect(() => {
    enableSubtitleByDefault();
  }, []);

  useEffect(() => {
    const subtitles = [];
    for (let i = 0; i < props.subtitles.length; i++) {
      subtitles.push({
        id: xingPlayer.videojs.addRemoteTextTrack(
          {
            kind: 'captions',
            label: props.subtitles[i].label,
            src: props.subtitles[i].sources?.find((s) => s.type === 'WEBVTT')
              ?.source,
            mode: 'hidden',
            id: 'track_' + i,
          },
          false
        ).track.id,
        label: props.subtitles[i].label,
        selected: false,
      });
    }
    subtitles.push({
      id: 'none',
      label: 'none',
      selected: true,
    });

    setSubtitles(subtitles);
  }, [props.subtitles]);

  const enableSubtitleByDefault = (): void => {
    if (shouldDisplaySubtitle) {
      const defaultIndex = props.subtitles.findIndex(
        (sub) => sub.label.toLowerCase() === 'de'
      );
      if (defaultIndex >= 0) {
        changeSubtitle(subtitles[defaultIndex]);
      }
    }
  };

  const changeSubtitle = (item: { id: string }): void => {
    const tracks = xingPlayer.videojs.textTracks();

    for (let i = 0; i < subtitles.length; i++) {
      const track =
        tracks[tracks.findIndex((track: any) => track.id === subtitles[i].id)];

      if (subtitles[i].id === item.id) {
        if (track) track.mode = 'showing';
        subtitles[i].selected = true;
      } else {
        if (track) track.mode = 'hidden';
        subtitles[i].selected = false;
      }
    }

    setSubtitles(subtitles);
  };

  const updateMenu = (): void => {
    xingPlayer.setMenu?.('subtitle', subtitles, (item: { id: string }) =>
      changeSubtitle(item)
    );
  };

  if (subtitles.length <= 1) {
    return null;
  }
  return (
    <Styled.ButtonContainer>
      <Styled.Button
        className="vjs-xing-subtitles vjs-control vjs-button"
        type="button"
        onClick={() => updateMenu()}
      >
        <span aria-hidden="true" className="vjs-icon-placeholder" />
      </Styled.Button>
    </Styled.ButtonContainer>
  );
};
